import React from 'react';
import MenuTop from '../../common/MenuTop/MenuTop.js';
// import logo from '../../images/logo.svg';
import './NavTop.css';

const NavTop = (props) => {
   return (
     <div className="NavTop-container">
       {/* <img alt="logo" src={logo} className="NavTop-logo"/> */}
       <MenuTop pageOn={props.pageOn} />
       {/* <Placeholder {...props} />   */}
     </div>
   )
 }

 export default NavTop;




// WEBPACK FOOTER //
// ./src/containers/NavTop/NavTop.js